import PropTypes from 'prop-types';
import React from 'react';
import Image from 'next/image';

import { ContentWrapper, OptionsLink } from './SidebarMain.styled';
import { pushGTMEvent } from 'pubweb-smokey/dist/utils/analytics';

const eventTitles = {
  porches: 'porches',
  islands: 'islands',
  cabinets: 'cabinets',
  'ecobee®': 'ecobee',
  flooring: 'flooring',
  'entertainment centers': 'entertainment',
  'open floor plan': 'floorplan',
  'flex spaces': 'flexspace',
  'tile options': 'tile',
  'tubs & walk-in showers': 'showers',
  'double sinks': 'doublevanity',
  'walk-in closets': 'closet',
};
class SidebarMain extends React.Component {
  shouldComponentUpdate(nextProps) {
    if (this.props.data !== nextProps.data) {
      return true;
    }

    return false;
  }

  render() {
    const { data } = this.props;
    let isTransitioning = true;

    if (data) {
      return (
        <ContentWrapper mobileFlex="row" isTransitioning={isTransitioning}>
          <div className="image-container">
            <Image className="image" src={data.image} alt="" fill />
          </div>
          <div>
            <p className="blurb">{data.blurb}</p>
            <OptionsLink
              onClick={() => {
                this.props.toggleDrawer();
                pushGTMEvent(
                  'ch.cta_click',
                  `dtr_ifp_${eventTitles[data.title.toLowerCase()]}`,
                  {
                    location: 'Interactive Floor Plan',
                    category: 'home_education',
                    action: 'text',
                    label: `dtr_ifp_${eventTitles[data.title.toLowerCase()]}`,
                  }
                );
              }}
            >
              See all options &gt;
            </OptionsLink>
          </div>
        </ContentWrapper>
      );
    } else {
      return (
        <ContentWrapper mobileFlex="column">
          <p className="side-description">
            Because our homes are built-to-order, we’re able to incorporate the
            latest in modern design. So
            <span className="desktop-click">click</span>
            <span className="mobile-tap">tap</span>
            around and discover some of our favorite features.*
          </p>

          <p className="disclaimer">
            * Not available in all homes. Please get in touch with your home
            consultant to discuss what upgrades are available for your home.
          </p>
        </ContentWrapper>
      );
    }
  }
}

SidebarMain.propTypes = {
  data: PropTypes.shape({
    blurb: PropTypes.any,
    image: PropTypes.any,
    title: PropTypes.string,
  }),
  toggleDrawer: PropTypes.func,
};

export default SidebarMain;
